export enum Script {
  CLOUDINARY = 'https://unpkg.com/cloudinary-video-player@1.9.9/dist/cld-video-player.light.min.js',
}
